import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Input,
  Spinner,
  Badge,
  Alert,
} from "reactstrap";
import Select from "react-select";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import {
  postSubmitForm,
  postSubmitForm_withformdata,
} from "../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../helpers/show_notification";
import preloader from "../../../helpers/preloader";
import {
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";
import calculatePrice from "../../../helpers/calculate_price";
import ReplaceItemModal from "../ReplaceItemModal";
import UpdateQuantityModal from "../../../components/UpdateQuantityModal";
import EnterQuantityModal from "../../../components/EnterQuantityModal";
import { CheckExpiryDateValidation } from "../../../helpers/po_helper";
import ReceiveConfirmationDialog from "../../../components/ReceiveConfirmationDialog";

const BranchPORequests = (props) => {
  const [POItems, setPOItems] = useState([]);
  const store_id = localStorage.getItem("store_id");
  // const is_manual_entry_allowed = localStorage.getItem("is_manual_entry_allowed") === "true";
  const oneYearFromNow = moment().add(1, "year").format("YYYY-MM-DD");
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
    loadAllItems();
    loadMappedItems();
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      loadAllPORequests();
    }
  }, [dateFrom, dateTo]);

  const [allPORequests, setAllPORequests] = useState([]);
  const loadAllPORequests = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "branchporequests/getall";
    const response = await postSubmitForm(url, {
      date_from: dateFrom,
      date_to: dateTo,
    });
    if (response && response.status === 1) {
      const sortedData = response.data.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      preloader(false);
      setAllPORequests(sortedData);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };
  const [replaceItemModal, setReplaceItemModal] = useState(false);
  const [allMappedItems, setAllMappedItems] = useState([]);
  const [selectedItemForReplacement, setSelectedItemForReplacement] =
    useState(null);
  const loadMappedItems = async () => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "items/get_mapped_items";
      const response = await postSubmitForm(url, { store_id: store_id });
      if (response && response.status === 1) {
        const selectOptions = response.data
          .filter((d) => d.is_active)
          .map((item) => ({
            _id: item.item_id,
            name: item.name,
            unit_levels: item.unit_levels,
            available: item.available,
            unit_for_po: item.unit_for_po,
            is_po_allowed: item.is_po_allowed,
            po_price: Number(item.po_price),
            store_available: item.store_available,
            threshold: item.threshold,
            unit_for_threshold: item.unit_for_threshold,
            category: item.category,
            sub_category: item.sub_category,
            max_order_limit: item.max_order_limit,
            unit_for_max_order: item.unit_for_max_order,
            is_premium_item: item.is_premium_item,
            label: item.name,
            value: item.item_id,
          }));
        setAllMappedItems(selectOptions);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error");
    } finally {
      preloader(false);
    }
  };

  const [itemsModal, setItemsModal] = useState();
  const [selectedPO, setSelectedPO] = useState();
  function editFormatter(cell, row) {
    if (row.purchaseorders.length > 0) {
      return (
        <>
          <span className=" mr-2">
            <i
              className="mdi mdi-text-box-search font-size-15"
              title="View Details"
              style={{ cursor: "pointer" }}
              onClick={async () => {
                let url =
                  process.env.REACT_APP_BASEURL + "purchaseorders/get_by_id";
                const response = await postSubmitForm(url, {
                  id: row.purchaseorders[0]._id,
                });
                const updatedData = response.data?.items?.map((item) => {
                  return {
                    ...item,
                    isFullyReceived: item.receive?.every(
                      ({ value }) => value == 0 || value === "",
                    ),
                    receive: item.receive?.map((obj, index) => ({
                      index,
                      unit: obj.unit,
                      value: obj.value,
                      isChecked: true,
                    })),
                  };
                });
                if (response && response.status === 1) {
                  setSelectedPO(response.data);
                  loadAllReplacements(response.data.po_id);
                  let arr = JSON.parse(JSON.stringify(updatedData));
                  arr.forEach((obj) => (obj.expiry_date = oneYearFromNow));
                  setPOItems(arr);
                  setInvoiceNumber();
                  setIsDisabled(false);
                  setInvoice();
                } else {
                  showNotification(response.message, "Error");
                }

                setItemsModal(!itemsModal);
              }}
            ></i>
          </span>
          <span className="mr-2 text-info">
            <a
              href={"/purchase_order?po_id=" + row.purchaseorders[0]._id}
              target="_blank"
              className="font-size-11"
            >
              <i
                className="mdi mdi-printer font-size-15"
                title="Print PO"
                style={{ cursor: "pointer" }}
              ></i>
            </a>
          </span>
        </>
      );
    }
  }
  const hasTemporaryDetails = Boolean(
    selectedPO?.temporary_delivery_details?.length,
  );

  const [selectedItem, setSelectedItem] = useState();
  const [receiveModal, setReceiveModal] = useState(false);
  function ReceiveFormatter(cell, row) {
    let isDisabled = row.isFullyReceived;
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.receive && row.receive)}
          </span>
          {selectedPO && selectedPO.status != "Closed" && (
            <Button
              className="btn btn-success btn-sm"
              hidden={hasTemporaryDetails || isDisabled}
              onClick={() => {
                let updatedItem = {
                  ...row,
                  quantity: row.receive?.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setSelectedRowsUnit(row.receive);
                setReceiveModal(!receiveModal);
              }}
            >
              <i class="mdi mdi-edit"></i>
              {props.t("Edit")}
            </Button>
          )}
        </div>
      </>
    );
  }

  const [allReplacemnets, setAllReplacemnets] = useState([]);
  const loadAllReplacements = async (po_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL + "purchaseorders/replacement_details";
      const response1 = await postSubmitForm(url, { po_id: po_id });
      if (response1 && response1.status === 1) {
        preloader(false);
        setAllReplacemnets(response1.data);
      } else {
        preloader(false);
        // showNotification(response1.message, "Error");
      }
    } catch (error) {
      // showNotification(error)
    } finally {
      preloader(false);
    }
  };

  const [allItems, setAllItems] = useState([]);
  const loadAllItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "items/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      let filtered = response.data?.filter((d) => d.is_active) || [];
      setAllItems(filtered);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const columns = [
    {
      dataField: "_id",
      hidden: true,
      style: { cursor: "pointer" },
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Request ID"),
      dataField: "request_id",
      sort: true,
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (cell, row) =>
        moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sort: true,
    },
    {
      text: props.t("Status"),
      dataField: "status",
      sort: true,
    },
    {
      text: props.t("PO Status"),
      dataField: "purchaseorders[0].status",
      sort: true,
    },
    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const columns_replaced_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Old Item"),
      dataField: "old_item_details",
      formatter: (cell, row) => {
        let old_item = row.old_item_details;
        return (
          <>
            <Row>
              <Col lg={3} md={3} sm={3}>
                <strong>Name</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.name}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Order Quantity</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {formatUnitsForReport(old_item?.quantity)}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Price</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.price}/{old_item?.unit_for_po}
              </Col>
              {/* <Col lg={3} md={3} sm={3}><strong>Formula</strong></Col>
            <Col lg={9} md={9} sm={9}>: &nbsp;&nbsp; {mapUnits(old_item?.unit_levels)}</Col> */}
            </Row>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "47%" };
      },
    },
    {
      text: props.t("Updated Item"),
      dataField: "new_item_details",
      formatter: (cell, row) => {
        let old_item = row.new_item_details;
        return (
          <>
            <Row>
              <Col lg={3} md={3} sm={3}>
                <strong>Name</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.name}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Order Quantity</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {formatUnitsForReport(old_item?.quantity)}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Price</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.price}/{old_item?.unit_for_po}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Remarks</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.remarks}
              </Col>
            </Row>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "47%" };
      },
    },
  ];

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    // {
    //   dataField: "sub_category",
    //   text: props.t("Sub-Category"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    //   editable: false,
    // },

    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.price + "/" + row.unit_for_po;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      editable: false,
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("To Receive"),
      editable: false,
      formatter: ReceiveFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        let isDisabled = row.isFullyReceived;
        if (selectedPO?.status === "Closed" || isDisabled) {
          return { cursor: "default" };
        }
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: true,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      editor: {
        type: Type.DATE,
      },
      hidden: selectedPO?.status === "Closed",
      validator: (newValue, row) => {
        const today = moment().startOf("day");

        if (!newValue) {
          return {
            valid: false,
            message: "Expiry date is required.",
          };
        }

        if (!moment(newValue).isValid()) {
          return {
            valid: false,
            message: "Please enter a valid date.",
          };
        }

        if (moment(newValue).isBefore(today)) {
          return {
            valid: false,
            message: "Expiry date cannot be in the past.",
          };
        }

        return true;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "",
      // hidden:!is_manual_entry_allowed,
      text: props.t("Replace"),
      sort: false,
      editable: false,
      hidden: selectedPO?.status === "Closed" || hasTemporaryDetails,
      formatter: (cell, row) => {
        return (
          <>
            {selectedPO.deliver_at_branch === true &&
              selectedPO.status !== "Delivered" &&
              selectedPO.status !== "Closed" && (
                <span className="d-flex justify-content-between">
                  <i
                    hidden={row.isFullyReceived}
                    style={{ fontSize: "25px", cursor: "pointer", color: "#" }}
                    title="Clik to replace Item"
                    className="mdi mdi-swap-horizontal info"
                    onClick={() => {
                      setSelectedItemForReplacement(row);
                      setReplaceItemModal(true);
                    }}
                  />
                </span>
              )}
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];

  const columns_delivered_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.price ? row.price + "/" + row.unit_for_po : 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      dataField: "free",
      text: props.t("Free"),
      formatter: (cell, row) => {
        return row.free ? "YES" : "NO";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("Received"),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.receive);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_date",
      text: props.t("Receiving Date"),
      editable: false,
      formatter: (cell, row) => {
        return moment(row.receiving_date).format("DD/MM/YYYY HH:mm");
      },

      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: false,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "invoice_number",
      text: props.t("Invoice"),
      editable: false,
      formatter: (cell, row) => {
        if (row.invoice_url) {
          return (
            <a href={row.invoice_url}>
              <i
                className="mdi mdi-download font-size-15"
                title="Download Invoice"
              ></i>
            </a>
          );
        } else {
          return row.invoice_number;
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];

  const columns_free_goods = [
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("To Receive"),
      editable: false,
      formatter: EditQuantity,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: true,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      editor: {
        type: Type.DATE,
      },
      validator: (newValue, row) => {
        const today = moment().startOf("day");

        if (!newValue) {
          return {
            valid: false,
            message: "Expiry date is required.",
          };
        }

        if (!moment(newValue).isValid()) {
          return {
            valid: false,
            message: "Please enter a valid date.",
          };
        }

        if (moment(newValue).isBefore(today)) {
          return {
            valid: false,
            message: "Expiry date cannot be in the past.",
          };
        }

        return true;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];

  const [addFreeunitModal, setAddFreeunitModal] = useState(false);
  const [freeGoods, setFreeGoods] = useState([]);
  function EditQuantity(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.receive && row.receive)}
          </span>
          {selectedPO.deliver_at_branch === true &&
            selectedPO.status !== "Delivered" &&
            selectedPO.status !== "Closed" && (
              <>
                {row.receive && row.receive?.length > 0 ? (
                  <Button
                    className="btn btn-success btn-sm"
                    onClick={() => {
                      let updatedItem = {
                        ...row,
                        quantity: row.receive?.map((item, idx) => ({
                          ...item,
                          index: idx,
                          isChecked: true,
                        })),
                      };
                      setSelectedItem(updatedItem);
                      setEditFreeunitModal(true);
                    }}
                  >
                    <i class="mdi mdi-edit"></i>
                    {props.t("Edit")}
                  </Button>
                ) : (
                  <Button
                    className="btn btn-success btn-sm"
                    onClick={() => {
                      setSelectedItem(row);
                      setAddFreeunitModal(!addFreeunitModal);
                    }}
                  >
                    <i class="mdi mdi-edit"></i>
                    {props.t("Add")}
                  </Button>
                )}
              </>
            )}
        </div>
      </>
    );
  }
  const handleSelectItems = (data, changedValue) => {
    // select logic
    if (changedValue.action === "select-option") {
      const modifiedData = data.map((item) => {
        return {
          item_id: item._id,
          _id: item._id,
          label: item.label,
          value: item.value,
          name: item.name,
          category: item.category,
          sub_category: item.sub_category,
          brand: item.brand,
          free: item.free && item.free,
          receive: item.receive && item.receive,
          unit_for_po: item.unit_for_po,
          price: 0,
          total_price: 0,
          expiry_date: oneYearFromNow,
          unit_levels: item.unit_levels,
        };
      });
      setFreeGoods(modifiedData);
    }
    if (changedValue.action === "remove-value") {
      let UpdatedSelectedItem = freeGoods?.filter(
        (item) => item.label !== changedValue.removedValue.label,
      );
      setFreeGoods(UpdatedSelectedItem);
    }
  };

  const [isDisabled, setIsDisabled] = useState(false);
  const [showReceiveConfirm, setShowReceiveConfirm] = useState(false);

  const handleReceiveItems = async (e) => {
    e.preventDefault();

    const expiryValidation = CheckExpiryDateValidation(
      POItems,
      freeGoods || [],
    );
    if (!expiryValidation.isValid) {
      showNotification(expiryValidation.message, "Warning");
      return;
    }
    setShowReceiveConfirm(true);
  };
  const processReceiveItems = async (data) => {
    try {
      let updatedPOItems;
      if (data.freeGoods && data.freeGoods.length > 0) {
        updatedPOItems = data.POItems.concat(data.freeGoods);
      } else {
        updatedPOItems = data.POItems;
      }

      let item_to_send = updatedPOItems
        // .filter((obj) => obj.receive?.some(({ value }) => (value != 0)))
        .map((item) => ({
          item_id: item.item_id,
          name: item.name,
          category: item.category,
          sub_category: item.sub_category,
          brand: item.brand,
          unit_for_po: item.unit_for_po,
          price: +item.price,
          free: item.free == "yes" ? true : false,
          total_price:
            item.free != "yes"
              ? calculatePrice(
                  item.unit_levels,
                  item.receive,
                  item.price,
                  item.unit_for_po,
                )
              : 0,
          _id: item._id,
          unit_levels: item.unit_levels.map(({ unit, value }) => ({
            unit,
            value,
          })),
          quantity: item.quantity?.length > 0 ? item.quantity : [],
          expiry_date: item.expiry_date,
          receive: item.receive.map((receiveItem) => ({
            unit: receiveItem.unit,
            value: Number(receiveItem.value),
          })),
        }));

      let formData = new FormData();
      formData.set("id", selectedPO._id);
      formData.set("delivery_details", JSON.stringify(item_to_send));
      formData.append("invoice_number", data.invoiceNumber);
      formData.append("invoice", data.invoice);

      setIsDisabled(true);
      // let url = process.env.REACT_APP_BASEURL + "purchaseorders/receive";
      // This route is added to temporarily save delivery details for CSM review before final receipt in inventory
      let url =
        process.env.REACT_APP_BASEURL + "purchaseorders/temporary_receive";
      const response = await postSubmitForm_withformdata(url, formData);

      if (response && response.status === 1) {
        setIsDisabled(false);
        loadAllPORequests();
        setItemsModal(!itemsModal);
        setFreeGoods([]);
        showNotification(response.message, "Success");
      } else {
        setIsDisabled(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false);
      showNotification("Error processing request", "Error");
    }
  };

  const [editFreeunitModal, setEditFreeunitModal] = useState(false);
  const [freeGoodsModal, setFreeGoodsModal] = useState(false);
  const handlAddFreeGoods = () => {
    const isValid = freeGoods.every(
      (item) => item.receive && item.receive.every((row) => row.value == 0),
    );
    if (isValid) {
      showNotification("Enter valid quantity for each item", "Warning");
      return;
    }
    setFreeGoodsModal(!freeGoodsModal);
  };
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [invoice, setInvoice] = useState();

  const handleDownload = async () => {
    const fileName = "all_po_requests";
    const exportType = "xls";

    let data_to_export = allPORequests;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          RequestID: v.request_id,
          Date: moment(v.createdAt).format("DD/MM/YYYY HH:mm"),
          Status: v.status,
          POStatus:
            v.purchaseorders.length > 0 ? v.purchaseorders[0].status : "",
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  // for free goods
  const handleAddUnits = (quantity) => {
    // console.log(quantity,"from free");
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    const updatedCartItems = freeGoods.map((item) => {
      if (item._id === selectedItem._id) {
        // return { ...item, receive: selectedRowsUnit.map(row => ({ unit: row.unit, value: row.value })), free: "yes" };
        return { ...item, receive: convertedQuantity, free: "yes" };
      } else {
        return item;
      }
    });
    setFreeGoods(updatedCartItems);
    setSelectedItem([]);
    setSelectedRowsUnit([]);
    setAddFreeunitModal(false);
  };

  const handleUpdateUnit = (quantity) => {
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    const isItemInCart = freeGoods.some(
      (item) => item.item_id === selectedItem.item_id,
    );
    if (isItemInCart) {
      const updatedCartItems = freeGoods.map((item) =>
        item.item_id === selectedItem.item_id
          ? {
              ...item,
              receive: convertedQuantity,
            }
          : item,
      );
      setFreeGoods(updatedCartItems);
      setEditFreeunitModal(false);
    } else {
      const newItem = {
        ...selectedItem,
        receive: convertedQuantity,
      };
      setFreeGoods((prevCartItems) => [...prevCartItems, newItem]);
      setEditFreeunitModal(false);
    }
  };

  const handleSubmit = (quantity) => {
    // event.preventDefault();
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    setReceiveModal(!receiveModal);
    const updatedItems = POItems.map((item) => {
      if (item._id === selectedItem._id) {
        return { ...item, receive: convertedQuantity };
        // return selectedItem;
      }
      return item;
    });
    setSelectedRowsUnit([]);
    setSelectedItem();
    setPOItems(updatedItems);
  };

  const [isReplacing, setIsReplacing] = useState(false);
  const handleItemReplace = async (replacementData) => {
    try {
      setIsReplacing(true);
      let payload = {
        purchase_order_id: selectedPO._id,
        old_item_id: replacementData.originalItem.item_id,
        new_item_details: replacementData.replacementItem,
        remark: replacementData.replacementItem.remarks,
      };
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/replace_item";
      const response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        let data = POItems?.filter(
          (dat) => replacementData.originalItem.item_id !== dat.item_id,
        );
        setPOItems([...data, replacementData.replacementItem]);
        loadAllReplacements(selectedPO.po_id);
        showNotification(response.message, "Success");
        setReplaceItemModal(false);
        return true;
      } else {
        showNotification(response.message, "error");
        return true;
      }
    } catch (error) {
      showNotification(error, "error");
      return true;
    } finally {
      setIsReplacing(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Procurement")}
            alternateTitle={props.t("All PO Requests")}
            breadcrumbItem1={props.t("All PO Requests")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={6}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("All PO Requests")}
                    </CardTitle>
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allPORequests && allPORequests}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4} className="text-right">
                              {/* <button
                              className="btn-sm btn btn-info"
                              onClick={() => {
                                setAddInventoryModal(!addInventoryModal);
                              }}
                            >
                              Add Item
                            </button> */}
                            </Col>
                          </Row>
                          <BootstrapTable
                            // rowEvents={rowEvents}
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="lg"
                    style={{
                      minWidth: "1200px",
                      maxWidth: "1200px",
                    }}
                    isOpen={itemsModal}
                    toggle={() => setItemsModal(!itemsModal)}
                  >
                    <ModalHeader toggle={() => setItemsModal(!itemsModal)}>
                      Purchase Order ID: {selectedPO && selectedPO.po_id}
                    </ModalHeader>
                    <ModalBody>
                      {selectedPO && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <Label>Ordered Items</Label>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={POItems && POItems}
                                        columns={columns_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              cellEdit={cellEditFactory({
                                                mode: "click",
                                                blurToSave: true,
                                              })}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                    {selectedPO.deliver_at_branch == true &&
                                      selectedPO.status !== "Delivered" &&
                                      selectedPO.status !== "Closed" &&
                                      !hasTemporaryDetails && (
                                        <>
                                          <Col lg={12}>
                                            <Row>
                                              <Col lg={12}>
                                                <AvForm
                                                  onValidSubmit={
                                                    handleReceiveItems
                                                  }
                                                >
                                                  <Row>
                                                    <Col lg={4}>
                                                      <Label>
                                                        Invoice Number
                                                      </Label>
                                                      <AvField
                                                        type="text"
                                                        name="invoice_number"
                                                        value={invoiceNumber}
                                                        onChange={(e) =>
                                                          setInvoiceNumber(
                                                            e.target.value,
                                                          )
                                                        }
                                                        placeholder={props.t(
                                                          "Enter invoice no. here...",
                                                        )}
                                                        validate={{
                                                          required: {
                                                            value: true,
                                                            errorMessage:
                                                              props.t(
                                                                "Invoice no. is required.",
                                                              ),
                                                          },
                                                          minLength: {
                                                            value: 3,
                                                            errorMessage:
                                                              props.t(
                                                                "must be at least 3 characters.",
                                                              ),
                                                          },
                                                        }}
                                                      />
                                                    </Col>
                                                    <Col lg={4}>
                                                      <Label>
                                                        Upload Invoice Document
                                                      </Label>
                                                      <Input
                                                        type="file"
                                                        id="invoice"
                                                        className="form-control-file"
                                                        onChange={(e) => {
                                                          setInvoice(
                                                            e.target.files[0],
                                                          );
                                                        }}
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg={4}
                                                      className="d-flex align-items-end mb-4"
                                                    >
                                                      <div
                                                        style={{
                                                          position: "relative",
                                                          display:
                                                            "inline-block",
                                                        }}
                                                      >
                                                        <Button
                                                          type="button"
                                                          color="info"
                                                          className="btn btn-info waves-effect waves-light"
                                                          onClick={() =>
                                                            setFreeGoodsModal(
                                                              !freeGoodsModal,
                                                            )
                                                          }
                                                        >
                                                          <i className="bx bx-add-to-queue me-1"></i>
                                                          {props.t(
                                                            "Add Free Goods",
                                                          )}
                                                        </Button>

                                                        {freeGoods?.length >
                                                          0 && (
                                                          <Badge
                                                            pill
                                                            color="danger"
                                                            className="cart-badge"
                                                            style={{
                                                              position:
                                                                "absolute",
                                                              top: "-8px",
                                                              right: "-8px",
                                                              fontSize:
                                                                "0.75rem",
                                                              minWidth: "20px",
                                                              height: "20px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              zIndex: 1000,
                                                              border:
                                                                "2px solid #fff",
                                                            }}
                                                          >
                                                            {freeGoods?.length}
                                                          </Badge>
                                                        )}
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      lg={12}
                                                      className="text-center mt-3"
                                                    >
                                                      <Button
                                                        type="submit"
                                                        color="primary"
                                                        style={{
                                                          width: "140px",
                                                        }}
                                                        disabled={isDisabled}
                                                        className="btn btn-default waves-effect waves-light"
                                                      >
                                                        {isDisabled ? (
                                                          <Spinner size="sm" />
                                                        ) : (
                                                          props.t(
                                                            "Receive Items",
                                                          )
                                                        )}
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                </AvForm>
                                              </Col>
                                            </Row>
                                            <hr className="mt-2" />
                                          </Col>
                                        </>
                                      )}
                                  </Row>
                                  <Row>
                                    {selectedPO?.delivery_details?.length >
                                      0 && (
                                      <Col lg={12}>
                                        <Label>Delivered Items</Label>
                                        <ToolkitProvider
                                          keyField="_id"
                                          data={
                                            selectedPO &&
                                            selectedPO.delivery_details
                                          }
                                          columns={columns_delivered_items}
                                        >
                                          {(props) => (
                                            <div>
                                              <BootstrapTable
                                                {...props.baseProps}
                                                // cellEdit={cellEditFactory({
                                                //   mode: "click",
                                                //   blurToSave: true,
                                                // })}
                                                noDataIndication="No data to display."
                                                striped
                                                hover
                                                condensed
                                              />
                                            </div>
                                          )}
                                        </ToolkitProvider>
                                      </Col>
                                    )}

                                    {selectedPO?.temporary_delivery_details
                                      ?.length > 0 && (
                                      <Col lg={12}>
                                        <Alert color="warning" className="mt-2">
                                          Received items are yet to be confirmed
                                          by <b>CSM</b>. After confirmation, you
                                          will be able to receive them again if
                                          any item is pending.
                                        </Alert>
                                        <Label>Received Items</Label>

                                        <ToolkitProvider
                                          keyField="_id"
                                          data={
                                            selectedPO &&
                                            selectedPO?.temporary_delivery_details.filter(
                                              (obj) =>
                                                obj.receive?.some(
                                                  ({ value }) => value != 0,
                                                ),
                                            )
                                          }
                                          columns={columns_delivered_items}
                                        >
                                          {(props) => (
                                            <div>
                                              <BootstrapTable
                                                {...props.baseProps}
                                                noDataIndication="No data to display."
                                                striped
                                                hover
                                                condensed
                                              />
                                            </div>
                                          )}
                                        </ToolkitProvider>
                                      </Col>
                                    )}
                                  </Row>

                                  {/* Replaced Items  */}
                                  {allReplacemnets &&
                                    allReplacemnets?.length > 0 && (
                                      <Row>
                                        <Col lg={12}>
                                          <Label>Replaced Items</Label>
                                          <ToolkitProvider
                                            keyField="old_item_details._id"
                                            data={allReplacemnets}
                                            columns={columns_replaced_items}
                                          >
                                            {(props) => (
                                              <div>
                                                <BootstrapTable
                                                  {...props.baseProps}
                                                  noDataIndication="No data to display."
                                                  striped
                                                  hover
                                                  condensed
                                                />
                                              </div>
                                            )}
                                          </ToolkitProvider>
                                        </Col>
                                      </Row>
                                    )}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* Update Receive  Quantity for  PO Items */}
                  <UpdateQuantityModal
                    isOpen={receiveModal}
                    toggle={() => setReceiveModal(false)}
                    onSubmit={handleSubmit}
                    item={selectedItem}
                  />

                  {/* --- Replace Item Modal Start --- */}
                  <ReplaceItemModal
                    isOpen={replaceItemModal}
                    toggle={() => setReplaceItemModal(false)}
                    originalItem={selectedItemForReplacement}
                    allItems={allMappedItems}
                    isLoading={isReplacing}
                    onReplace={handleItemReplace}
                  />
                  {/* --- Replace Item Modal End --- */}

                  {/* Free goods modal  */}
                  <Modal
                    size="lg"
                    isOpen={freeGoodsModal}
                    toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                  >
                    <ModalHeader
                      toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                    >
                      {props.t("Add Free Goods")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={6}>
                          <Label>{props.t("Items")}</Label>
                          <Select
                            options={allItems}
                            value={freeGoods}
                            onChange={(data, changedValue) =>
                              handleSelectItems(data, changedValue)
                            }
                            closeMenuOnSelect={true}
                            classNamePrefix="select"
                            isMulti={true}
                            className="basic-multi-select"
                          />
                        </Col>
                      </Row>
                      <Row className="mt-5">
                        <Col lg={12}>
                          <Label>{props.t("Free Goods")}</Label>
                          <ToolkitProvider
                            keyField="_id"
                            data={freeGoods || []}
                            columns={columns_free_goods}
                          >
                            {(props) => (
                              <div>
                                <BootstrapTable
                                  {...props.baseProps}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  noDataIndication="No data to display."
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            )}
                          </ToolkitProvider>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col lg={12}>
                          <FormGroup className="mb-0 text-center">
                            <div>
                              <Button
                                type="submit"
                                color="primary"
                                className="mr-1"
                                onClick={() => handlAddFreeGoods()}
                              >
                                {props.t("Submit")}
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* Add unit modal  */}
                  <EnterQuantityModal
                    // selectedQuantity={selectedRowsUnit}
                    isOpen={addFreeunitModal}
                    toggle={() => setAddFreeunitModal(false)}
                    onSubmit={handleAddUnits}
                    item={selectedItem}
                  />

                  {/* Edit Units Modal  */}
                  <UpdateQuantityModal
                    isOpen={editFreeunitModal}
                    toggle={() => setEditFreeunitModal(false)}
                    onSubmit={handleUpdateUnit}
                    item={selectedItem}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ReceiveConfirmationDialog
            isOpen={showReceiveConfirm}
            onConfirm={() => {
              setShowReceiveConfirm(false);
              processReceiveItems({
                POItems,
                freeGoods,
                invoiceNumber,
                invoice,
              });
            }}
            onCancel={() => {
              setShowReceiveConfirm(false);
            }}
            hasFreeGoods={freeGoods?.length > 0}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(BranchPORequests)),
);
